import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { getProjectsListApi } from '@src/api';
import { GetProjectsParams } from '@src/api/projects/projects';
export const getProjectsList = createAsyncThunk(
  'company/getProjectsList',
  async (
    {
      page = 1,
      limit = 20,
      sortBy = [''],
      searchBy = 'name',
      search = '',
      filter = {
        companyId: '',
      },
    }: GetProjectsParams,
    { rejectWithValue }
  ) => {
    try {
      const response = await getProjectsListApi({
        page,
        limit,
        sortBy,
        searchBy,
        search,
        filter,
      });
      return response.result.data;
    } catch (err) {
      if (axios.isAxiosError(err)) {
        return rejectWithValue(err.response?.data);
      }

      throw err;
    }
  }
);
